import { Injectable } from '@angular/core';
import { AppServerAPI, Identity, ServiceResponse } from '@sdbn/common';
import { Observable } from 'rxjs';
import { Route, RoutingPosition, TransportRouting, TransportRoutingIdentity } from '../routing-position.model';

@Injectable({
  providedIn: 'root'
})
export class TransportRoutingService {

  constructor(private appServerAPI: AppServerAPI) { }

  getTransportRouting(identity: TransportRoutingIdentity): Observable<TransportRouting> {
    return this.appServerAPI.execute<TransportRouting>(`/client/control/change/transportrouting/routing`, identity);
  }

  save(transportRouting: TransportRouting): Observable<ServiceResponse> {
    return this.appServerAPI.execute<ServiceResponse>(`/client/control/change/transportrouting/save`, transportRouting);
  }

  getPositionsforTransportProfile(identity: Identity): Observable<RoutingPosition[]> {
    return this.appServerAPI.execute(`/client/control/transport/registration/profile-positions`, identity);
  }

  reloadRoute(identity: Identity): Observable<Route> {
    return this.appServerAPI.execute(`/client/control/change/transportrouting/reload-route`, identity);
  }
}
